function ScrollDown(container) {
    this.container = container;
    this.el = this.container.querySelector('.jsScrollDown');

    this.el.addEventListener('click', e => {
        e.preventDefault();

        const rect = document.querySelector('.jsScrollDownTarget').getBoundingClientRect();
        TweenLite.to(window, 0.9, { scrollTo: rect.top - 80, ease: Power2.easeInOut });
    });

    this.animate();

    // Fade the element out on scroll
    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({ offset: 0, duration: 400 })
        .setTween(this.el, { y: -30, opacity: 0 })
        .addTo(controller)
    ;
};

ScrollDown.prototype.animate = function() {
    const lines = this.el.querySelectorAll('.line');

    new TimelineMax({ repeat: -1 })
        .staggerTo(lines, 0.5, { opacity: 1, ease: Power2.easeIn }, '0.05', '0.5')
        .staggerTo(lines, 0.5, { opacity: 0.2, ease: Power2.easeOut }, '0.05', '-=0.2')
    ;
};
function ParallaxScrolling(container) {
    this.container = container;

    // Setup the controller
    const controller = new ScrollMagic.Controller({ globalSceneOptions: { duration: '100%' } });
    const enterController = new ScrollMagic.Controller({ globalSceneOptions: { triggerHook: 'onEnter', duration: '200%' } });

    const title = container.querySelector('.jsHomeIntroTitle');
    const contentWrapper = container.querySelector('.jsHomeIntroContentWrapper');
    const videoWrapper = container.querySelector('.jsDocumentaryPreviewElements > div');

    if (videoWrapper && contentWrapper) {
        const scene = new ScrollMagic.Scene({ triggerElement: contentWrapper })
            .setTween([title, contentWrapper], { y: '-200%', opacity: 0, ease: Power0.easeNone })
            .addTo(controller)
        ;

        if (window.innerWidth < 850) scene.enabled(false);
        else scene.enabled(true);

        window.addEventListener('resize', _ => {
            if (window.innerWidth < 850) scene.enabled(false);
            else scene.enabled(true);
        });
    }

    // Animate the tour background images
    const tourBg1 = this.container.querySelector('.jsTourAlbumRows .row1');
    const tourBg2 = this.container.querySelector('.jsTourAlbumRows .row2');

    new ScrollMagic.Scene({ triggerElement: tourBg1 })
        .setTween(tourBg1, { x: '-3%', ease: Power0.easeNone })
        .addTo(enterController);
    ;

    new ScrollMagic.Scene({ triggerElement: tourBg2 })
        .setTween(tourBg2, { x: '3%', ease: Power0.easeNone })
        .addTo(enterController);
    ;
};
function SideScroll(container) {
    this.container = container;
    this.buttons = this.container.querySelectorAll('.jsSideMenu button');
    this.triggerElements = Array.prototype.map.call(this.buttons, btn => this.container.querySelector('[data-id="' + btn.dataset.trigger + '"]'));

    inView.threshold(0.3);

    inView('.jsSideMenuInViewEl')
        .on('enter', el => {
            for (let i = 0; i < this.buttons.length; i++) this.buttons[i].classList.remove('active');
            this.container.querySelector('.jsSideMenu button[data-trigger="' + el.dataset.id + '"]').classList.add('active');
        })
    ;

    Array.prototype.forEach.call(this.buttons, el => {
        el.addEventListener('click', e => {
            e.preventDefault();

            const trigger = el.dataset.trigger;
            const triggerEl = this.container.querySelector('[data-id="' + trigger + '"]');

            vanillaSmoothie.scrollTo(Math.ceil(triggerEl.offsetTop - (window.innerHeight / 100 * 15)), {
                duration: 800,
                easing: 'easeInOutQuad'
            })
        });
    });
};
function VideoModal(youtubeVideoId) {
    document.addEventListener('keyup', e => {
        if (e.keyCode === 27) {
            const videoModal = document.querySelector('.video-modal');
            if (videoModal) this.closeModal(videoModal);
        }
    });

    this.createModal(youtubeVideoId);
    this.openModal();
};

VideoModal.prototype.createModal = function(youtubeVideoId) {
    this.modal = document.createElement('div');
    this.modal.classList.add('video-modal');

    const videoUrl = 'https://www.youtube.com/embed/' + youtubeVideoId + '?autoplay=1';
    const visualEl = '<iframe width="640" height="360" class="video-modal__video" src="' + videoUrl + '" frameborder="0" allowfullscreen></iframe>';

    this.modal.innerHTML =
        '<div class="video-modal__inner">' +
            '<div class="video-modal__wrapper">' +
                '<a class="video-modal__close-button">Close</a>' +
                '<div class="video-modal__video-wrapper">' + visualEl + '</div>' +
            '</div>' +
        '</div>'
    ;

    // Add the modal to the DOM
    this.modal.style.opacity = '0';
    document.body.appendChild(this.modal);

    // Init the close button
    this.modal.querySelector('.video-modal__close-button').addEventListener('click', e => {
        e.preventDefault();
        this.closeModal(this.parentElement);
    });

    // Init closing when clicking next to the video
    this.modal.addEventListener('click', e => {
        if (e.target.classList.contains('video-modal__video-wrapper')) {
            this.closeModal();
        }
    });

    // Add escape close listener
    document.addEventListener('keyup', e => {
        if (e.keyCode === 27) this.closeModal();
    });

    // Init iframe aspect ratio
    const iframe = this.modal.querySelector('iframe');
    const definedWidth = iframe.getAttribute('width');
    const definedHeight = iframe.getAttribute('height');
    const aspectRatio = [1, (definedHeight / definedWidth)];

    this.setIframeAspectRatio(iframe, aspectRatio);
    window.addEventListener('resize', _ => this.setIframeAspectRatio(iframe, aspectRatio));
};

VideoModal.prototype.openModal = function() {
    TweenLite.to(this.modal, 0.5, { opacity: 1, ease: Power2.easeInOut });
};

VideoModal.prototype.closeModal = function() {
    TweenLite.to(this.modal, 0.5, { opacity: 0, onComplete: _ => this.modal.parentElement.removeChild(this.modal) });
};

VideoModal.prototype.setIframeAspectRatio = function(iFrameElement, ratio) {
    iFrameElement.style.width = '';
    iFrameElement.style.height = '';

    let newHeight = (iFrameElement.offsetWidth / ratio[0]) * ratio[1];

    const offset = window.innerWidth >= 850 ? 200 : 100;

    if (newHeight > (window.innerHeight - offset)) {
        newHeight = window.innerHeight - offset;
        iFrameElement.style.width = (newHeight / ratio[1] * ratio[0]) + 'px';
    }

    iFrameElement.style.height = newHeight + 'px';
};
function DocumentaryPreview(container) {
    this.container = container;
    this.previewElementWrapper = this.container.querySelector('.jsDocumentaryPreviewElements');
    this.buttons = this.container.querySelectorAll('.jsDocumentaryPreviewBtnWrapper button');
    this.videos = this.previewElementWrapper.querySelectorAll('.preview');
    this.playButton = this.previewElementWrapper.querySelector('.jsVideoPlayButton');
    this.nextSlideTime = 6000;
    this.nextSlideInterval = null;
    this.currentSlideIndex = 0;
    this.introSlideWrapper = this.container.querySelector('.jsHomeIntroSlideWrapper');
    this.introSlides = this.container.querySelectorAll('.jsHomeIntroSlide');
    this.timeIndicators = this.container.querySelectorAll('.jsTimeIndicator');
    this.gsapTimelines = [];

    setTimeout(_ => this.activatePreview(0), 3000);

    Array.prototype.forEach.call(this.buttons, btn => {
        btn.addEventListener('click', _ => this.activatePreview(parseInt(btn.dataset.index)));
    });

    if (! document.querySelector('html').classList.contains('touchevents')) {
        this.previewElementWrapper.querySelector('div').addEventListener('mousemove', e => {
            TweenLite.to(this.playButton, 0.5, { left: e.offsetX, top: e.offsetY, opacity: 1 });
        });

        this.previewElementWrapper.addEventListener('mouseout', _ => {
            TweenLite.to(this.playButton, 0.2, { opacity: 0 })
        });
    }

    this.setCountdown();
    setInterval(this.setCountdown.bind(this), 60 * 10);

    this.initPreviewTriggers();

    this.setSlideWrapperHeight();
    window.addEventListener('resize', this.setSlideWrapperHeight.bind(this));
};

DocumentaryPreview.prototype.setSlideWrapperHeight = function() {
    this.introSlideWrapper.style.height = '';
    let maxHeight = 0;

    for (let i = 0; i < this.introSlides.length; i++) {
        this.introSlides[i].style.display = 'block';

        const height = this.introSlides[i].offsetHeight;
        if (height > maxHeight) maxHeight = height;

        this.introSlides[i].style.display = '';
    }

    this.introSlideWrapper.style.height = maxHeight + 'px';
};

DocumentaryPreview.prototype.nextSlide = function() {
    if ((this.currentSlideIndex + 1) <= (this.videos.length - 1)) this.activatePreview(this.currentSlideIndex + 1);
    else this.activatePreview(0);
};

DocumentaryPreview.prototype.setTimeInterval = function() {
    if (this.nextSlideInterval) clearInterval(this.nextSlideInterval);
    this.nextSlideInterval = setInterval(this.nextSlide.bind(this), this.nextSlideTime);

    // Pause the current timelines
    for (let j = 0; j < this.gsapTimelines.length; j++) this.gsapTimelines[j].pause();
    this.gsapTimelines = [];

    // Activate the indicators and set others to 0 width
    for (let i = 0; i < this.timeIndicators.length; i++) {
        const slideIndex = parseInt(this.timeIndicators[i].parentElement.dataset.index);

        if (slideIndex === this.currentSlideIndex) {
            this.gsapTimelines.push(gsap.timeline()
                .set(this.timeIndicators[i], { width: 0 })
                .to(this.timeIndicators[i], this.nextSlideTime / 1000, { width: '100%', ease: Linear.easeNone }))
            ;
        }
        else {
            gsap.set(this.timeIndicators[i], { width: 0 });
        }
    }
};

DocumentaryPreview.prototype.activatePreview = function(index) {
    this.currentSlideIndex = index;
    this.setTimeInterval();

    for (let i = 0; i < this.videos.length; i++) {
        if (i === index) {
            if (this.buttons[i].dataset.type === 'video') {
                if (this.videos[i].classList.contains('not-available')) this.playButton.classList.add('not-available');
                else this.playButton.classList.remove('not-available');

                this.playButton.classList.remove('url');
            }
            else {
                this.playButton.classList.add('url');
                this.playButton.classList.remove('video-available');
                this.playButton.classList.remove('not-available');
                this.playButton.querySelector('.custom').innerHTML = this.buttons[i].dataset.titleOverlayBtn;
            }

            this.videos[i].classList.add('active');
            this.buttons[i].classList.add('active');
        }
        else {
            this.videos[i].classList.remove('active');
            this.buttons[i].classList.remove('active');
        }
    }

    // Set the active status
    for (let i = 0; i < this.introSlides.length; i++) {
        if (parseInt(this.introSlides[i].dataset.index) === index) this.introSlides[i].classList.add('active');
        else this.introSlides[i].classList.remove('active');
    }
}

DocumentaryPreview.prototype.setCountdown = function() {
    const availabilityDates = this.container.querySelectorAll('.jsPartAvailabilityDate');

    if (availabilityDates.length > 0) {
        Array.prototype.forEach.call(availabilityDates, el => {
            el.innerHTML = moment(el.dataset.date, "YYYYMMDD hh:mm").fromNow();
        });
    }
};

DocumentaryPreview.prototype.initPreviewTriggers = function() {
    const triggers = this.container.querySelectorAll('.jsPreviewTrigger');

    Array.prototype.forEach.call(triggers, trigger => {
        trigger.addEventListener('click', e => {
            e.preventDefault();
            new VideoModal(trigger.dataset.videoId);
        });
    });
};
function BGShape(container) {
    this.container = container;
    this.mobileDetect = new MobileDetect(window.navigator.userAgent);

    this.shape = this.container.querySelector('.jsBgShape');
    this.shapeLines = this.shape.querySelectorAll('span');

    this.skewXMin = -35;
    this.skewXDiff = 12;

    this.skewYMin = -5;
    this.skewYDiff = 8;

    this.prevMobileX = this.skewXMin;
    this.prevMobileY = this.skewYMin;

    // Init
    this.setLineFades();

    // Set the initial transform
    TweenLite.set(this.shape, { skewX: this.skewXMin, skewY: this.skewYMin, rotationZ: 30 });
    TweenLite.to(this.shape, 3, { opacity: 0.2, ease: Power4.easeInOut });

    if (! this.mobileDetect.mobile()) {
        // Rotate the element when the mouse moves
        window.addEventListener('mousemove', e => {
            const percentX = (e.screenX / window.innerWidth * 100);
            const percentY = (e.screenY / window.innerHeight * 100);

            const skewX = this.skewXMin + -(this.skewXDiff / 100 * percentX);
            const skewY = this.skewYMin + -(this.skewYDiff / 100 * percentY);

            TweenLite.to(this.shape, 9, { skewX: skewX, skewY: skewY, opacity: 0.2, overwrite: 'all', ease: Power4.easeOut });
        });
    }
    else {
        this.animateMobile();
    }
};

BGShape.prototype.animateMobile = function() {
    const x = this.randomValue(this.skewXMin, this.skewXMin + this.skewXDiff);
    const y = this.randomValue(this.skewYMin, this.skewYMin + this.skewYDiff);

    const difference = Math.abs(Math.abs(this.prevMobileX - x) + Math.abs(this.prevMobileY - y));
    const maxDifference = this.skewXDiff + this.skewYDiff;
    const diffPercentage = difference / maxDifference * 100;

    const time = 10 / 100 * diffPercentage;

    this.prevMobileX = x;
    this.prevMobileY = y;

    TweenLite.to(this.shape, time, {
        skewX: x,
        skewY: y,
        ease: Power4.easeInOut,
        onComplete: this.animateMobile.bind(this),
        opacity: 0.2
    });
};

BGShape.prototype.setLineFades = function() {
    const lineCount = this.shapeLines.length;
    const percentage = 100 / lineCount;
    
    for (let i = 0; i < lineCount; i++) {
        TweenLite.set(this.shapeLines[i], { opacity: ((100 - (percentage * i)) / 100) });
    }
};

BGShape.prototype.randomValue = function(min, max) {
    if (max == null) { max = min; min = 0; }
    if (min > max) { var tmp = min; min = max; max = tmp; }
    return min + (max - min) * Math.random();
};
function InViewAnimation() {
    this.scrollDirectionUp = false;
    this.scrollPos = 0;

    // Set the scroll direction
    window.addEventListener('scroll', e => {
        this.scrollDirectionUp = this.scrollPos > window.scrollY;
        this.scrollPos = window.scrollY;
    });

    inView.offset(0);

    // Animate elements in when entering the view
    inView('.in-view-up')
        .on('enter', el => el.classList.add('done'))
        .on('exit', el => {
            inView.offset(0);
            if (this.scrollDirectionUp) el.classList.remove('done');
        })
    ;
};
function Lightbox(element) {
    const imgUrl = element.href;

    this.anchor = element;

    this.lightbox = document.createElement('div');
    this.lightbox.classList.add('lightbox');
    this.lightbox.style.opacity = 0;

    const lightboxInner = document.createElement('div');
    lightboxInner.classList.add('lightbox__inner');
    lightboxInner.classList.add('jsCloseLightbox');
    this.lightbox.appendChild(lightboxInner);

    const contentWrapper = document.createElement('div');
    contentWrapper.classList.add('lightbox__content-wrapper');
    lightboxInner.appendChild(contentWrapper);

    const closeBtn = document.createElement('button');
    closeBtn.classList.add('lightbox__close-btn');
    closeBtn.classList.add('jsCloseLightbox');
    closeBtn.type = 'button';
    closeBtn.innerHTML = 'Close';
    contentWrapper.appendChild(closeBtn);

    const img = document.createElement('img');
    img.src = imgUrl;
    contentWrapper.appendChild(img);

    // Add the lightbox to the DOM
    document.body.appendChild(this.lightbox);

    // Add event listeners
    this.lightbox.addEventListener('click', e => {
        if (e.target.classList.contains('jsCloseLightbox')) this.hide();
    });

    // Add escape close listener
    this.bindKeyupEvent = this.keyUp.bind(this);
    document.addEventListener('keyup', this.bindKeyupEvent, true);
};

Lightbox.prototype.keyUp = function(e) {
    switch (e.keyCode) {
        case 27 : this.hide(); break;
        case 37 : this.switchPhoto(false); break;
        case 39 : this.switchPhoto(true); break;
    }
};

Lightbox.prototype.show = function() {
    document.body.classList.add('no-overflow');

    TweenLite.to(this.lightbox, 0.3, { opacity: 1, ease: Power2.easeInOut, onComplete: _ => {
        TweenLite.set(this.lightbox, { clearProps: 'all' });
    } });
};

Lightbox.prototype.hide = function() {
    TweenLite.to(this.lightbox, 0.3, { opacity: 0, ease: Power2.easeInOut, onComplete: _ => {
        document.body.classList.remove('no-overflow');
        document.body.removeChild(this.lightbox);
        document.removeEventListener('keyup', this.bindKeyupEvent, true);
    } });
};

Lightbox.prototype.switchPhoto = function(isNext) {
    const group = this.anchor.dataset.lightboxGroup;
    if (group === undefined) return;

    const groupItems = [...document.querySelectorAll('[data-lightbox-group="' + group + '"]')];
    if (groupItems.length <= 1) return;

    const currentIndex = groupItems.indexOf(this.anchor);

    let nextAnchor = groupItems[((currentIndex + 1) > (groupItems.length - 1)) ? 0 : currentIndex + 1];
    if (! isNext) nextAnchor = groupItems[((currentIndex - 1) < 0) ? groupItems.length - 1 : currentIndex - 1];
    if (nextAnchor === undefined) return;

    this.lightbox.querySelector('img').src = nextAnchor.href;
    this.anchor = nextAnchor;
};

(() => {
    if (document.body.classList.contains('page-template-page-home')) {
        new ScrollDown(document.body);
        new ParallaxScrolling(document.body);
        new SideScroll(document.body);
        new DocumentaryPreview(document.body);
        new BGShape(document.body);
        new InViewAnimation();
    }
})();
(() => {
    if (document.body.classList.contains('post-type-archive-nr_music')) {
        new ScrollDown(document.body);
        new InViewAnimation();

        initSideScroll();
        initHighlightArrows();
    }

    function initSideScroll() {
        const buttons = document.querySelectorAll('.jsSideYears button');

        inView.offset({
            top: window.innerHeight / 2,
            bottom: window.innerHeight / 2
        });

        window.addEventListener('resize', _ => {
            inView.offset({
                top: window.innerHeight / 2,
                bottom: window.innerHeight / 2
            });
        });

        inView('.jsDiscoGridYear')
            .on('enter', el => {
                for (let i = 0; i < buttons.length; i++) buttons[i].classList.remove('active');

                const element = document.querySelector('.jsSideYears button[data-year-trigger="' + el.dataset.year + '"]');
                if (element) element.classList.add('active');
            })
        ;

        Array.prototype.forEach.call(buttons, el => {
            el.addEventListener('click', e => {
                e.preventDefault();

                const trigger = el.dataset.yearTrigger;
                const triggerEl = document.querySelector('[data-year="' + trigger + '"]');
                const offset = triggerEl.getBoundingClientRect();

                TweenLite.to(window, 0.8, { scrollTo: (offset.top + window.scrollY) - 100, ease: Power2.easeInOut });
            });
        });
    }

    function initHighlightArrows() {
        const elements = document.querySelectorAll('.jsHighlightSongImg');
        
        Array.prototype.forEach.call(elements, el => {
            const arrow = el.querySelector('.jsHighlightSongArrow');

            el.addEventListener('mouseenter', _ => {
                TweenLite.to(arrow, 0.5, { opacity: 1, ease: Power2.easeInOut });
            });

            el.addEventListener('mouseleave', _ => {
                if (el.parentElement.parentElement.classList.contains('highlight-song--even')) {
                    TweenLite.to(arrow, 1.5, { bottom: '18%', left: 22, ease: Power2.easeOut });
                }
                else {
                    TweenLite.to(arrow, 1.5, { right: 20, bottom: '18%', ease: Power2.easeOut });
                }
            });

            el.addEventListener('mousemove', e => {
                const elWidth = el.offsetWidth;
                const elHeight = el.offsetHeight;
                const mouseX = e.layerX;
                const mouseY = e.layerY;

                if (el.parentElement.parentElement.classList.contains('highlight-song--even')) {
                    const left = e.layerX;
                    const bottom = elHeight - mouseY - arrow.offsetHeight;

                    TweenLite.to(arrow, 0.8, { bottom: bottom, left: left, ease: Power2.easeOut });
                }

                else {
                    const right = elWidth - mouseX - arrow.offsetWidth;
                    const bottom = elHeight - mouseY - arrow.offsetHeight;

                    TweenLite.to(arrow, 0.8, { right: right, bottom: bottom, ease: Power2.easeOut });
                }
            });
        });
    }
})();
(() => {
    if (document.body.classList.contains('single-nr_album')) {
        new BGShape(document.body);
        new ScrollDown(document.body);
    
        initLightboxes();
    
        imagesLoaded(document.body.querySelector('.jsMasonryGrid'), () => {
            initMasonry();
            new InViewAnimation();
        });
    }

    function initMasonry() {
        const grid = document.body.querySelector('.jsMasonryGrid');

        const masonry = new Masonry(grid, { itemSelector: '.jsGridItem' });
        setTimeout(_ => masonry.layout(), 200);
    }

    function initLightboxes() {
        const triggers = document.body.querySelectorAll('.jsGridItem a');

        Array.prototype.forEach.call(triggers, el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                new Lightbox(el).show();
            });
        });
    }
})();
(() => {
    if (document.body.classList.contains('single-nr_redefine_item')) {
        new ScrollDown(document.body);
        new BGShape(document.body);

        imagesLoaded(document.querySelector('.jsMasonryGrid'), () => {
            initMasonry();
        });
    }

    function initMasonry() {
        const grid = document.querySelector('.jsMasonryGrid');
        const masonry = new Masonry(grid, { itemSelector: '.jsGridItem' });
        setTimeout(_ => masonry.layout(), 200);
    }
})();
(() => {
    if (document.body.classList.contains('page-template-default')) {
        initLightboxes();
        initImageSliders();

        const masonryGrid = document.querySelector('.jsMasonryGrid');

        if (masonryGrid !== null) {
            imagesLoaded(masonryGrid, _ => {
                initMasonry(masonryGrid);
                new InViewAnimation();
            });
        }
        else {
            new InViewAnimation();
        }
    }

    function initMasonry(grid) {
        const masonry = new Masonry(grid, { itemSelector: '.jsGridItem' });
        setTimeout(_ => masonry.layout(), 200);
    }

    function initLightboxes() {
        const triggers = document.querySelectorAll('.jsLightbox');

        Array.prototype.forEach.call(triggers, el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                new Lightbox(el).show();
            });
        });
    }

    function initImageSliders() {
        const sliders = document.querySelectorAll('.jsImageSlider .jsSlides');

        imagesLoaded(sliders, _ => {
            Array.prototype.forEach.call(sliders, el => {
                const flickity = new Flickity(el, {
                    pageDots: false,
                    prevNextButtons: false,
                    wrapAround: true,
                    adaptiveHeight: true,
                    draggable: false
                });

                const slideCountEl = el.parentElement.querySelector('.jsSlideCount');
                const slideCount = el.querySelectorAll('.jsSlide').length;

                // Set the slide counter
                slideCountEl.innerHTML = '01/' + addZero(slideCount);

                const btnPrev = el.parentElement.querySelector('.jsArrowPrev');
                const btnNext = el.parentElement.querySelector('.jsArrowNext');

                btnPrev.addEventListener('click', e => {
                    e.preventDefault();
                    flickity.previous(true);
                });
                
                btnNext.addEventListener('click', e => {
                    e.preventDefault();
                    flickity.next(true);
                });

                // Update the slide counter on slide
                flickity.on('change', index => {
                    slideCountEl.innerHTML = addZero(index + 1) + '/' + addZero(slideCount);
                });
            });
        });
    }

    function addZero(number) {
        if (number < 10) return '0' + number;
        return '' + number;
    }
})();
(() => {
    if (document.body.classList.contains('page-template-page-tourdates')) {
        new BGShape(document.body);
    }
})();
// if (document.readyState === 'complete') initBarba();
// else document.onreadystatechange = _ => {
//     if (document.readyState === 'complete') initBarba();
// }


// // Fade transition
// const BarbaFadeTransition = Barba.BaseTransition.extend({
//     start: function() {
//         let fadeOutComplete = false;
//         let newContainerLoaded = false;

//         TweenLite.to(this.oldContainer, 1, { opacity: 0, ease: Power4.easeInOut, onComplete: _ => {
//             fadeOutComplete = true;
//             if (newContainerLoaded) this.finish();
//         } });

//         this.newContainerLoading.then(_ => {
//             TweenLite.set(this.newContainer, { position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, opacity: 0 });
//             newContainerLoaded = true;
//             if (fadeOutComplete) this.finish();
//         });
//     },
//     finish: function() {
//         document.body.scrollTop = 0;
//         document.documentElement.scrollTop = 0;

//         TweenLite.set(this.newContainer, { display: 'block', visibility: 'visible', opacity: 0 });
//         TweenLite.to(this.newContainer, 1, { opacity: 1, ease: Power4.easeInOut, onComplete: _ => {
//             document.body.scrollTop = 0;
//             document.documentElement.scrollTop = 0;

//             TweenLite.set(this.newContainer, { clearProps: 'all' });
//             this.done();
//         } });
//     }
// });

// Barba.Pjax.getTransition = function() {
//     return BarbaFadeTransition;
// };

// function initBarba() {
//     Barba.Pjax.Dom.wrapperId = 'site-wrapper';
//     Barba.Pjax.Dom.containerClass = 'page-section__container';
//     Barba.Prefetch.init();
//     Barba.Pjax.start();
// }
(function() {
    const iframeEls = document.querySelectorAll('.default-styles iframe');

    [...iframeEls].forEach(el => setIframeAspectRatio(el, [16, 9]));
    window.addEventListener('resize', _ => [...iframeEls].forEach(el => setIframeAspectRatio(el, [16, 9])));
})();

function setIframeAspectRatio(el, aspectRatio) {
    el.style.height = ((el.offsetWidth / aspectRatio[0]) * aspectRatio[1]) + 'px';
}

function SplashScreen() {
    // const mainWrapper = document.querySelector('.jsMainWrapper');
    const splashScreen = document.querySelector('.jsSplashScreen');
    if (!splashScreen) return;

    const logo = document.querySelector('.jsSplashLogo');
    const strokedLetters = logo.querySelectorAll('.stroked path');
    const filledLettersGroup = logo.querySelector('.filled');

    new TimelineMax({ delay: 0.2 })
        // .set(mainWrapper, { opacity: 0 })
        .set(strokedLetters, { drawSVG: '0%' })
        .set(logo, { scale: 0.9 })
        .to(logo, 2, { scale: 1, opacity: 1, ease: 'power2.inOut' })
        .to(strokedLetters, 2, { drawSVG: '100%', ease: 'power2.inOut' }, '-=2')
        .to(filledLettersGroup, 0.5, { opacity: 1, ease: 'power2.easeOut' }, '-=0.3')
        .to(logo, 0.5, { scale: 0.9, opacity: 0, ease: 'power2.inOut' })
        .to(splashScreen, 0.8, { opacity: 0, ease: 'power2.inOut' })
        .set(splashScreen, { display: 'none' })
    ;
};

SplashScreen.prototype.shuffleArray = function(array) {
    let currentIndex = array.length, temporaryValue, randomIndex;

    while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
};
new SplashScreen();

function MobileMenu() {
    this.trigger = document.querySelector('.jsMobileMenuTrigger');
    this.mobileMenu = document.querySelector('.jsMobileMenu');
    this.menuItems = this.mobileMenu.querySelectorAll('.menu li');
    this.closeBtn = this.mobileMenu.querySelector('.jsMobileMenuCloseBtn');
    this.socialIcons = this.mobileMenu.querySelector('.jsSocialIcons');

    this.mobileMenu.addEventListener('click', e => {
        if (e.target.tagName.toLowerCase() === 'a') this.hideMenu();
    });

    this.trigger.addEventListener('click', e => {
        e.preventDefault();
        this.openMenu();
    });

    this.closeBtn.addEventListener('click', e => {
        e.preventDefault();
        this.hideMenu();
    });

    window.addEventListener('resize', _ => {
        if (window.innerWidth >= 850) {
            document.body.classList.remove('mobile-menu-open');
        }
    });
};

MobileMenu.prototype.openMenu = function() {
    new TimelineMax()
        .set(this.mobileMenu, { display: 'block', opacity: 0 })
        .set(this.menuItems, { y: 15, opacity: 0 })
        .set(this.socialIcons, { y: 15, opacity: 0 })

        .to(this.mobileMenu, 0.6, { opacity: 1, ease: Power2.easeInOut })
        .staggerTo(this.menuItems, 1.2, { y: 0, opacity: 1, ease: Power2.easeOut }, '0.06', '-=0.2')
        .to(this.socialIcons, 0.6, { y: 0, opacity: 1, ease: Power2.easeOut }, '-=1')

        .add(_ => {
            document.body.classList.add('mobile-menu-open');
            TweenLite.set([this.mobileMenu, this.menuItems, this.socialIcons], { clearProps: 'all' });
        })
    ;
};

MobileMenu.prototype.hideMenu = function() {
    new TimelineMax()
        .staggerTo(this.menuItems, 0.6, { y: 15, opacity: 0, ease: Power2.easeOut }, '0.08')
        .to(this.mobileMenu, 0.6, { opacity: 0, ease: Power2.easeInOut }, '-=0.4')
        .to(this.socialIcons, 0.6, { y: 15, opacity: 1, ease: Power2.easeInOut }, '-=0.6')

        .add(_ => {
            document.body.classList.remove('mobile-menu-open');
            TweenLite.set([this.mobileMenu, this.menuItems, this.socialIcons], { clearProps: 'all' });
        });
    ;
};
new MobileMenu();

function MainMenu() {
    this.mainMenu = document.querySelector('.jsMainMenu');
    this.menuItemsWithChildren = this.mainMenu.querySelectorAll('li.menu-item-has-children');

    // Don't run on touch devices
    if (document.documentElement.classList.contains('touchevents')) return;

    this.menuItemsWithChildren.forEach(el => {
        const submenuEl = el.querySelector('.sub-menu');
        const menuItemEls = submenuEl.querySelectorAll('li');
        let timeline = null;
        let hover = false;

        el.addEventListener('mouseover', () => {
            if (timeline) timeline.kill();

            if (hover) return;
            hover = true;

            timeline = gsap.timeline()
                .set(submenuEl, { opacity: 0 })
                .set(menuItemEls, { opacity: 0.2 })

                .to(submenuEl, { duration: 0.5, opacity: 1, ease: 'power2.inOut' })
                .to(menuItemEls, { duration: 0.5, opacity: 1, ease: 'power2.inOut', stagger: 0.1 }, '-=0.4')

                .set([submenuEl, menuItemEls], { clearProps: 'all' })
            ;
        });

        el.addEventListener('mouseleave', () => {
            if (timeline) timeline.kill();
            hover = false;

            const submenuEl = el.querySelector('.sub-menu');

            timeline = gsap.timeline()
                .to(submenuEl, { duration: 0.5, display: 'flex', opacity: 0, ease: 'power2.inOut' })
                .set(submenuEl, { clearProps: 'all' })
            ;
        });
    });
};
new MainMenu();

function Footer() {
    this.preventCheck = false;

    // Set the footer visibility
    window.addEventListener('scroll', this.setFooterVisibility.bind(this));
    this.setFooterVisibility();

    Barba.Dispatcher.on('initStateChange', _ => {
        this.preventCheck = true;
    });

    Barba.Dispatcher.on('transitionCompleted', _ => {
        this.preventCheck = false;
        this.setFooterVisibility();
    });
};

Footer.prototype.setFooterVisibility = function() {
    if (!this.preventCheck) {
        if (document.body.offsetHeight > 0 && window.scrollY + window.innerHeight >= document.body.offsetHeight - 100) document.body.classList.add('bottom-pushup');
        else document.body.classList.remove('bottom-pushup');
    }
};
new Footer();

function ContactModal() {
    this.trigger = document.querySelector('.jsTriggerContactModal');
    this.modal = document.querySelector('.jsModalContact');
    this.modalInner = this.modal.querySelector('.jsModalInner');

    this.trigger.addEventListener('click', e => {
        e.preventDefault();
        this.show();
    });

    this.modal.addEventListener('click', e => {
        if (e.target.classList.contains('jsCloseModal')) {
            e.preventDefault();
            this.hide();
        }
    });
};

ContactModal.prototype.show = function() {
    new TimelineMax()
        .set(this.modal, { display: 'flex', opacity: 0 })
        .set(this.modalInner, { y: 30, opacity: 0 })
        
        .to(this.modal, 0.5, { opacity: 1, ease: Power2.easeInOut })
        .to(this.modalInner, 0.5, { y: 0, opacity: 1, ease: Power2.easeOut })
    ;
};

ContactModal.prototype.hide = function() {
    new TimelineMax()
        .to(this.modalInner, 0.5, { y: 30, opacity: 0, ease: Power2.easeInOut })
        .to(this.modal, 0.5, { opacity: 0, ease: Power2.easeInOut })
        .set(this.modal, { clearProps: 'all' })
    ;
};
new ContactModal();